import { UserRef } from '$tablet-app/src/app/auth/UserModel';
import { ProfileIcon } from '$tablet-app/src/app/components/ProfileIcon/ProfileIcon';
import Row from '$tablet-app/src/app/components/Row';
import { Text } from '$tablet-app/src/app/components/Text/Text';
import React, { FC } from 'react';
import styled from 'styled-components/native';

interface Props {
  owner?: UserRef;
}

const StickyOwner: FC<Props> = ({ owner }) => {
  return owner ? (
    <Row alignItems="center">
      <ProfileIcon profile={owner} />
      <OwnerText bold>FROM {owner.name}</OwnerText>
    </Row>
  ) : null;
};

const OwnerText = styled(Text)`
  font-size: 14px;
  opacity: 0.8;
  margin-left: 10px;
  text-transform: uppercase;
`;

export default StickyOwner;
